var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"mx-auto w-75",attrs:{"tag":"main","fluid":""}},[_c('gallery',{attrs:{"images":_vm.images,"index":_vm.index},on:{"close":function($event){_vm.index = null}}}),_vm._l((_vm.images),function(image,imageIndex){return _c('div',{key:imageIndex,staticClass:"image",style:({
      backgroundImage: 'url(' + image + ')',
      width: '300px',
      height: '200px',
    }),on:{"click":function($event){_vm.index = imageIndex}}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }